import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { GameSettingsService } from "../../game-settings.service";

@Component({
  selector: "app-screen-emojis",
  templateUrl: "./screen-emojis.component.html",
  styleUrls: ["./screen-emojis.component.scss"],
})
export class ScreenEmojisComponent implements OnInit {
  @Input() checkExactOrEliminationInPrizes;
  @Input() assignEmojisToInviteImageArt;
  @Input() s3BucketUrl: string;
  @Input() prizeIndex: number; // Added the @Input for prizeIndex

  emojiListOptions: any;

  constructor(
    private gameSettingsService: GameSettingsService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    // In ScreenEmojisComponent
    this.emojiListOptions = {
      group: {
        name: "emojis",
        pull: "clone", // always clone on drag
        put: false, // never accept drops back into this list
      },
      sort: false, // no sorting/reordering of the source list
    };
  }

  addEmoji(item: any) {
    if (!this.gameSettingsService.winPattern[this.prizeIndex]) return;

    // Block adding emojis before a prize value is set (matches the drag-drop guard)
    const cashPrizeValue = this.gameSettingsService.winPattern[this.prizeIndex].cashPrizeValue;
    if (!cashPrizeValue) {
      this.snackBar.open("Please enter a prize value first", "OK", { duration: 2000 });
      return;
    }

    const targetList =
      this.gameSettingsService.winPattern[this.prizeIndex].cashPrizeImages;

    if (!targetList) return;

    // Limit to 6 items
    if (targetList.length >= 6) return;

    // Deduplicate by ID
    if (targetList.some((e) => e.id === item.id)) return;

    targetList.push({ id: item.id, image: item.image });
  }
}
